import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as Popover from "@radix-ui/react-popover";
import Icon from "@client.components/Icon";
import { makeProfile } from "@client.pages/Login/reducer";
import UpdateButton from "./UpdateButton";
import DeleteButton from "./DeleteButton";
import "./GridManagementButtons.scss";

const GridManagementButtons = ({ user }) => {
  const { t } = useTranslation();
  const profile = useSelector(makeProfile);

  return (
    <div
      className="grid-management-buttons"
      title={t(
        "components.UserManagementContent.GridManagementButtons.managementButtons"
      )}
    >
      <Popover.Root>
        <Popover.Trigger asChild>
          <button className={"management-button"}>
            <Icon name="dots" />
          </button>
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Content className="mb-popover-content">
            <UpdateButton user={user} />
            {profile.userId !== user.id && <DeleteButton user={user} />}
            <Popover.Arrow className="popover-arrow" />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
};

GridManagementButtons.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
    teams: PropTypes.array,
  }),
};

export default GridManagementButtons;
